import * as React from 'react';
const Progress = ({
  className,
  style,
  percent
}) => /*#__PURE__*/React.createElement("progress", {
  className: className,
  max: "100",
  value: percent,
  style: style
});
export default Progress;